// FE-SCRM-048 — REST client for the CSV import pipeline.
//
// Two-phase BE-SCRM-047 endpoints. The create endpoint takes
// multipart/form-data; the api client detects FormData and skips the
// JSON Content-Type header so the browser sets the multipart boundary.

import { api } from "@/api/client";

import type {
  ImportListResponse,
  ImportSession,
  ImportType,
} from "./types";


export function fetchImportList(
  opts?: { signal?: AbortSignal },
): Promise<ImportListResponse> {
  return api.get<ImportListResponse>("/api/v1/sales/imports", opts);
}


export function fetchImportDetail(
  session_id: string,
  opts?: { signal?: AbortSignal },
): Promise<ImportSession> {
  return api.get<ImportSession>(
    `/api/v1/sales/imports/${session_id}`,
    opts,
  );
}


export interface CreateImportInput {
  import_type: ImportType;
  file: File;
}


export function createImportSession(
  input: CreateImportInput,
): Promise<ImportSession> {
  const fd = new FormData();
  fd.append("import_type", input.import_type);
  fd.append("file", input.file);
  return api.post<ImportSession>("/api/v1/sales/imports", fd);
}


export function commitImport(session_id: string): Promise<ImportSession> {
  return api.post<ImportSession>(
    `/api/v1/sales/imports/${session_id}/commit`, {},
  );
}
